
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import PageLayout from "@/components/PageLayout";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    // 404 tracked by analytics if needed
  }, [location.pathname]);

  return (
    <PageLayout>
      <section className="pt-32 pb-16 bg-gradient-to-br from-gray-50 to-white min-h-[70vh] flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="text-center max-w-2xl mx-auto">
            <div className="w-20 h-1 bg-gradient-to-r from-red-500 to-red-600 mb-8 rounded-full mx-auto" />
            <h1 className="text-6xl md:text-8xl font-semibold text-neutral-900 mb-6 font-inter">
              404
            </h1>
            <p className="text-2xl md:text-3xl font-light text-neutral-700 mb-4 font-inter">
              Oops! Page not found
            </p>
            <p className="text-lg text-neutral-700 font-light mb-8 font-inter">
              The page you're looking for doesn't exist or has been moved.
            </p>
            <a 
              href="/" 
              className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-red-500 to-red-600 text-white rounded-lg hover:shadow-lg transition-all font-inter font-medium"
            >
              Return to Home
            </a>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default NotFound;
